// extracted by mini-css-extract-plugin
export default {"Box":"label-group-module__Box__u10r4X0"};